"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardProductCtaLinks = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = require("../../../base-components/Link/Link");
var _Sanitizer = require("../../../base-components/Sanitizer/Sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CardProductCtaLinks = exports.CardProductCtaLinks = function CardProductCtaLinks(props) {
  var namespace = props.namespace,
    productLinks = props.productLinks,
    styles = props.styles,
    className = props.className,
    qeId = props.qeId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'product-cta-links')
  }, productLinks.map(function (cta, index) {
    var children = typeof cta.children === 'string' ? /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
      Component: "span",
      safelySetInnerHTML: cta.children
    }) : cta.children;
    return cta.hide ? null : /*#__PURE__*/_react["default"].createElement(_Link.Link, {
      dtm: cta.dtm,
      className: (0, _classnames["default"])(styles.btnBlock, styles.primaryButton, styles.link, styles[cta.key]),
      title: cta.hoverText,
      href: cta.link,
      key: "CTA_link_".concat(index + 1),
      onClick: cta.onClick,
      Component: cta.component,
      target: cta.target,
      namespace: namespace,
      qeId: qeId ? "".concat(qeId, "-button").concat(index + 1) : undefined,
      "aria-label": cta['aria-label']
    }, children);
  }));
};
CardProductCtaLinks.propTypes = {
  productLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    children: _propTypes["default"].node,
    link: _propTypes["default"].string,
    hoverText: _propTypes["default"].string
  })),
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  className: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
CardProductCtaLinks.defaultProps = {
  productLinks: [],
  className: '',
  styles: {},
  hoverText: '',
  namespace: '',
  qeId: undefined
};